import React, { useState } from "react";
import LoadingSpinner from "../../../../components/Loadder";
import { postData, getData } from "../../../../serverRequest";
import { toast, ToastContainer } from 'react-toastify';
import { parse } from 'date-fns';


export default function IncidentForm(props) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const adminId = searchParams.get('admin_id');
  const [companyId, setCompanyId] = useState();
  const [totalEmployees, setTotalEmployees] = React.useState([]);
  const [activityName, setActivityName] = useState();
  const [complainDate, setComplainDate] = useState();
  const [resolutionDate, setResolutionDate] = useState(null);
  const [incidentClosureDuration, setIncidentClosureDuration] = useState([]);
  const [actualClosureDuration, setActualClosureDuration] = useState([]);
  const [handlerName, setHandlerName] = useState();
  const [status, setStatus] = useState();
  const [comments, setComments] = useState();
  const [incidenceResolutionComments, setIncidenceResolutionComments] = useState();
  const [incidenceResolutionDateTime, setIncidenceResolutionDateTime] = useState();
  const [complainRegisterDateTime, setComplainRegisterDateTime] = useState();


  const filterEmployeeData = (employee_data) => {
    //console.log(tickets_data);
    let totalEmployee = [];
    if (employee_data) {
      for (let i = 0; i < employee_data.length; i++) {
        totalEmployee.push(employee_data[i])
      }
    }

    setTotalEmployees(totalEmployee);
    return ({ "total": totalEmployee })
  }
  React.useEffect(() => {
    async function fetchData() {
      let resData = await getData('/api/employee/?company_id=' + localStorage.getItem('companyId') + '&is_list_employee=1');
      //let resData = await getData('/api/employee/admins/?is_admin=1')
      let employee_data = resData['data']['employee_data']
      console.log(employee_data);
      let adminData = await filterEmployeeData(employee_data)


      setLoading(false);
    }
    fetchData();


  }, [])

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    // let { 
    //   srNo, 
    //   activityName, 
    //   status, 
    //   comments, 
    //   incidenceResolutionComments, 
    //   handlerName, 
    //   complainRegisterDateTime, 
    //   incidenceResolutionDateTime, 
    //   incidenceClosureDuration, 
    //   actualClosureDuration 
    // } = document.forms[0];

    let formData = {
      'activity_name': activityName || '',
      'status': status || 'Inprogress',
      'comments': comments || '',
      'resolution_comments': incidenceResolutionComments || '',
      'handle_by': handlerName || '',
      'complain_date': complainDate || '',
      'resolution_date': resolutionDate || '',
      'incident_closure_duration': incidentClosureDuration || '',
      'actual_closure_duration': actualClosureDuration || '',
    };

    try {
      const resData = await postData("/api/employee/daily_incident/", formData);

      if (resData['data']['code'] === 200) {
        setLoading(false);
        setShowModal(true);
        toast.success('Incident submitted successfully!')
        window.location.href = '/admin/company/incidentList';
      } else {
        console.error('Failed to submit form:', resData.statusText);
        toast.error('Failed to submit incident: ' + resData['data']['message']);
        setLoading(false);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Error submitting incident: ' + error.message);
      setLoading(false);
    }
  };

  const calculateDuration = (start, end) => {
    if (!start || !end) return '';

    // Use new Date() to parse ISO 8601 format directly
    const startDate = new Date(start);
    const endDate = new Date(end);

    if (isNaN(startDate) || isNaN(endDate)) {
        console.error("Invalid dates provided for duration calculation.");
        return '';
    }

    const diffMs = endDate - startDate;
    console.log(`Start Date: ${startDate}, End Date: ${endDate}, Difference in ms: ${diffMs}`);

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    console.log(`Duration: ${hours} hours and ${minutes} minutes`);

    return `${hours}.${minutes.toString().padStart(2, '0')}`;
};

  const handleDateChange = async() => {
    console.log(`Complain Date: ${complainDate}, Resolution Date: ${resolutionDate}`);
    
    const duration = calculateDuration(complainDate, resolutionDate);
    if (duration) {
      setIncidentClosureDuration(duration);
      console.log(`Complain Date: ${complainDate}, Resolution Date: ${resolutionDate}, Duration: ${duration}`);
    } else {
      console.error("Invalid dates provided for duration calculation.");
    }
    setIncidentClosureDuration(duration);
    console.log(`Complain Date: ${complainDate}, Resolution Date: ${resolutionDate}, Duration: ${duration}`);
  };

  return (
    <div className="incident-form-container p-4 min-h-screen w-full">
      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            <div className="rounded-t bg-white mb-6 px-6 py-6">
              <div className="text-center flex justify-between">
                <h6 className="text-blueGray-700 text-xl font-bold">Incident Form</h6>
              </div>
            </div>
            <div className="flex flex-wrap justify-between">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Activity Name</label>
                  <input type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="activityName"
                    value={activityName}
                    onChange={(e) => setActivityName(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Status</label>
                  <select
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="Inprogress">Inprogress</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Comments</label>
                  <input type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="comments"
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Incidence Resolution Comments</label>
                  <input type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="incidenceResolutionComments"
                    value={incidenceResolutionComments}
                    onChange={(e) => setIncidenceResolutionComments(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Handler Name</label>
                  <select
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="handlerName"
                    value={handlerName}
                    onChange={(e) => setHandlerName(e.target.value)}
                  >
                    <option value="">Select Handler</option>
                    {totalEmployees.map((employee, index) => (
                      <option key={index} value={employee.id}>{employee.first_name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Complain Register Date & Time</label>
                  <input type="datetime-local"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="complainRegisterDateTime"
                    value={complainRegisterDateTime}
                    onChange={(e) => {
                      setComplainDate(e.target.value);
                      handleDateChange();
                    }}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Incidence Resolution Date & Time</label>
                  <input type="datetime-local"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="incidenceResolutionDateTime"
                    value={resolutionDate}
                    onChange={(e) => {
                      const selectedDate = new Date(e.target.value);
                      const complainDateObj = new Date(complainDate);
                      if (selectedDate < complainDateObj) {
                        alert("Resolution date cannot be earlier than complain registration date.");
                        e.target.value = resolutionDate; // Reset to previous value
                      } else {
                        setResolutionDate(e.target.value);
                        handleDateChange();
                      }
                    }}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Incidence Closure Duration (in hours)</label>
                  <input type="number"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="incidenceClosureDuration"
                    value={incidentClosureDuration}
                    readOnly
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Actual Closure Duration (in hours)</label>
                  <input type="number"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="actualClosureDuration"
                    value={actualClosureDuration}
                    onChange={(e) => setActualClosureDuration(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="text-center mt-6 lg:w-3/12 px-4">
              <input
                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-4 w-full ease-linear transition-all duration-150"
                type="Submit"
                value="Submit"
              />
            </div>
          </div>
        </form>
      )}
      <ToastContainer />
    </div>
  );
}
